import React, { Component } from 'react';
import BannerFront from '../assets/images/banner-front.png';
import LoginComponent from '../components/LoginComponent';
import { Tools } from '../utils/tools';

class HomePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            platform: Tools.platformDevice()
        }
    }

    componentDidMount() {
        localStorage.setItem('app_sp', '');
    }

    render() {
        const {
            platform
        } = this.state;

        return (
            <>
                <div className="container">
                    <div className="row app-layout-main">
                        {(platform === 'web') &&
                            <div className="col-sm-12 col-md-4" style={{ backgroundImage: 'url(' + BannerFront + ')', backgroundSize: 'contain', backgroundRepeat: 'no-repeat' }}>
                            </div>
                        }
                        <div className="col-sm-12 col-md-8 right-side-main">
                            <div className='cls-version-app'><span>versión 24.0.0</span></div>
                            <LoginComponent navigate={this.props.navigate} />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default HomePage;